import {
  Typography,
  TypographyMods,
  TypographySizes,
} from '@vk-cloud-solutions/marketing-ui';
import Link from 'next/link';

import { getTitleBacklightHex } from '~containers/MainPage/MainPage.utils';
import AttachIcon from '~public/static/images/icons/attach.svg';

import styles from './HeaderSection.module.scss';
import {
  HeaderSectionProps,
  TitleBacklightColors,
} from './HeaderSection.types';

export function HeaderSection({
  title,
  titleBacklight = TitleBacklightColors.Blue,
  href,
  countArticles,
  hasPageCategory,
  hasIcon,
}: HeaderSectionProps) {
  return (
    <header className={styles.header}>
      <div
        className={styles.titleBacklight}
        style={{ backgroundColor: getTitleBacklightHex(titleBacklight) }}
      />
      <Typography tagName={TypographySizes.h2} mods={[TypographyMods.titleL]}>
        {title}
      </Typography>
      {hasIcon && <AttachIcon />}
      {href && hasPageCategory && (
        <Link
          href={href}
          className={styles.link}
          data-testid="header-section_watch-all"
        >
          Смотреть все
          {countArticles ? (
            <span className={styles.count}> ({countArticles})</span>
          ) : null}
        </Link>
      )}
    </header>
  );
}
